import { Button, useTheme } from '@ytl/common-web';
import { useState } from 'react';
import QRCode from 'react-qr-code';
import { useLanguage } from '../../../../contexts/languageContext';
import { OnboardingPhase, OnboardingStepperControls } from '../../../../modules/onboarding/OnboardingComponent';
import { getConfig } from '../../../data/config';

type KYCWebProps = {
  stepper: OnboardingStepperControls;
};

export const KYCWeb = ({ stepper }: KYCWebProps) => {
  const { translation } = useLanguage();
  const { isWebView } = useTheme();
  const [showQrCodeMobile, setShowQrCodeMobile] = useState<boolean>(false);

  const [qrValue] = useState<string>(getConfig().yettelAppDownloadUrl || '');

  const handleBack = () => {
    stepper.goToPhase(OnboardingPhase.IdentifyMyself);
  };

  const handleToAppClick = () => {
    if (qrValue) {
      window.location.href = qrValue;
    }
  };

  const ShowQRCode = () => {
    return (
      <div className="onboarding-step__info-box">
        <div className="onboarding-step__info-box-inner">
          {qrValue ? (
            <QRCode
              value={qrValue}
              size={180}
              aria-label={translation.accessibility?.qrCode}
            />
          ) : null}
        </div>

        <p
          className="onboarding-step__info-box-text"
          dangerouslySetInnerHTML={{ __html: translation.onboarding?.kyc?.qrInstruction }}
        />
      </div>
    );
  };

  return (
    <div className={`onboarding-step${isWebView ? ' onboarding-step--webview' : ''}`}>
      <h3 className="onboarding-step__header">{translation.onboarding?.kyc?.headerWeb}</h3>

      <div className="hide-in-mobile-view">
        <p
          className="onboarding-step__description mb"
          dangerouslySetInnerHTML={{ __html: translation.onboarding?.kyc?.webTextFull1 }}
        />
        <p
          className="onboarding-step__description"
          dangerouslySetInnerHTML={{ __html: translation.onboarding?.kyc?.webTextFull2 }}
        />
        <div className="onboarding-step__qrCodeContainer">
          <ShowQRCode />
        </div>
      </div>

      <div className="hide-in-desktop-view">
        <p
          className="onboarding-step__description mb"
          dangerouslySetInnerHTML={{ __html: translation.onboarding?.kyc?.webTextMobile1 }}
        />
        <p
          className="onboarding-step__description"
          dangerouslySetInnerHTML={{ __html: translation.onboarding?.kyc?.webTextMobile2 }}
        />
        <p
          className="onboarding-step__description mb"
          dangerouslySetInnerHTML={{ __html: translation.onboarding?.kyc?.webTextMobile3 }}
        />
        <p
          className="onboarding-step__description mb"
          dangerouslySetInnerHTML={{ __html: translation.onboarding?.kyc?.webTextMobile4 }}
        />
        <p
          className="onboarding-step__description mb"
          dangerouslySetInnerHTML={{ __html: translation.onboarding?.kyc?.webTextMobile5 }}
        />
        <div className={`onboarding-step__actions${isWebView ? ' onboarding-step__actions--webview' : ''}`}>
          <Button
            variant="contained"
            onClick={handleToAppClick}
          >
            {translation.onboarding?.kyc?.continueToYettelApp}
          </Button>
          <div className="register-page__container__divider">
            <span>{translation.loginRegister.register.box.oauthSectionLabel}</span>
          </div>
          {showQrCodeMobile ? (
            <ShowQRCode />
          ) : (
            <Button
              variant="outlined"
              onClick={() => setShowQrCodeMobile(true)}
            >
              {translation.onboarding?.kyc?.showQRCode}
            </Button>
          )}
        </div>
      </div>

      {/* Back button */}

      <div className={`onboarding-step__back${isWebView ? ' onboarding-step__back--webview' : ''}`}>
        <Button
          variant="text"
          onClick={handleBack}
        >
          {translation.yeppRegistration?.webcomponent.back}
        </Button>
      </div>
    </div>
  );
};
